import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import CimaLanding from "@/pages/CimaLanding";
import Catalog from "@/pages/Catalog";
import ArticleOxigenoMedicinal from "@/pages/ArticleOxigenoMedicinal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CimaLanding />} />
          <Route path="/catalogo" element={<Catalog />} />
          <Route
            path="/articulos/venta-oxigeno-medicinal-zihuatanejo"
            element={<ArticleOxigenoMedicinal />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
